import {Diagram, Divider, DownloadButton, Row, TextBlock} from './comps';
import { Section } from './sections';
import dagpic from './diagrams/dagyt.png';
import * as introcontent from './content/intro';
import * as dagstuff from './content/dagstuff';
import * as differentiation from './content/differentiation';
import * as piece from './content/finalpiece';
import Md from 'react-markdown';
import d1 from './diagrams/d1.jpg';
import d2 from './diagrams/d2.jpg';
import d3 from './diagrams/d3.jpg';
import d4 from './diagrams/d4.jpg';
import d5 from './diagrams/d5.jpg';




export function Intro() {

    const dagpiccap = <a href='https://www.youtube.com/watch?v=wG_nF1awSSY'>
        <u>What is Automatic Differentiation? | Ari Seff</u>
    </a>;

    return (
        <Section>
            <TextBlock side='left'><Md>{introcontent.introtext0}</Md></TextBlock>
            <Row vcenter>
                <Diagram  scale src={dagpic} caption={dagpiccap} width={'35rem'} side={'left'}/>
                <TextBlock side='left'><Md>{introcontent.introtext1}</Md></TextBlock>
            </Row>
            <TextBlock side='left'><Md>{introcontent.introtext2}</Md></TextBlock>
        </Section>
    );
}




export function DiffStuff({ mode }) {
    return (
        <Section title={'Differentials'} mode={mode}>
            <TextBlock side='left'><Md>{differentiation.d1}</Md></TextBlock>
            <Diagram src={d1} width={'30rem'} side={'left'} center/>
            <TextBlock side='left'><Md>{differentiation.d2}</Md></TextBlock>
            <Row>
                <Diagram src={d2} width={'30rem'} side={'left'} scale caption={'Jacobian'}/>
                <TextBlock side='left'><Md>{differentiation.d3}</Md></TextBlock>
            </Row>
            <TextBlock side='left'><Md>{differentiation.d4}</Md></TextBlock>
        </Section>
    );
}



export function DAGStuff({ mode }) {
    return (
        <Section title={'DAG'} mode={mode}>
            <TextBlock side='left'><Md>{dagstuff.d1}</Md></TextBlock>
            <Row vcenter>
                <TextBlock side='left'><Md>{dagstuff.d2}</Md></TextBlock>
                <Diagram src={d3} width={'35rem'} side={'right'} caption={'DAG / computation graph'}/>
            </Row>
        </Section>
    );
}

export function TheFinalPiece({ mode }) {
    return (
        <Section title={'The Final Piece'} mode={mode}>
            <TextBlock side='left'><Md>{piece.d1}</Md></TextBlock>
            <Row>
                <TextBlock side='left'><Md>{piece.d2}</Md></TextBlock>
                <Diagram src={d4} height={'20rem'} side={'right'} caption={'Finding adjoints'}/>
            </Row>
            <TextBlock side='left'><Md>{piece.d3}</Md></TextBlock>
            <Section title='On Matrices' size='h3' mode={mode}>
                <TextBlock side='left'><Md>{piece.mat1}</Md></TextBlock>
                <Diagram src={d5} height={'20rem'} side={'left'} center caption={'Matrix Multiplication'}/>
                <TextBlock side='left'><Md>{piece.mat2}</Md></TextBlock>
                
            </Section>
            <Section title='Eager vs Lazy' size='h3' mode={mode}>
                <TextBlock side='left'><Md>{piece.eager}</Md></TextBlock>
            </Section>
        </Section>
    );
}


// export function DataStuff({ mode }) {
//     return (
//         <Section title='The Data (text)' mode={mode}>
//             <TextBlock>
//                 <Md>{datastuff.d1}</Md>
//             </TextBlock>
//             <CodeBlock>
//                 {datastuff.c1}
//             </CodeBlock>
//             <TextBlock>
//                 <Md>{datastuff.d2}</Md>
//             </TextBlock>
//         </Section>
//     );
// }


// export function Attention({ mode }) {
//     return (
//         <Section title='Pay Attention!' mode={mode}>
//             <Row>
//                 <TextBlock>
//                     <Md>{attention.intro}</Md>
//                 </TextBlock>
//                 <Diagram src={d9} height={'18rem'} caption={'Attention'} side={'right'}/>
//             </Row>
//             <TextBlock>
//                 <Md>{attention.motivation1}</Md>
//             </TextBlock>
//             <Diagram src={d8} height={'18rem'} center scale caption={'Identical embeddings'} side={'left'}/>
//             <TextBlock>
//                 <Md>{attention.motivation2}</Md>
//             </TextBlock>
//             <Section title={'Attention: Mechanism'} size='h3' mode={mode}>
//                 <TextBlock>
//                     <Md>{attention.preintro}</Md>
//                 </TextBlock>
//                 <Row>
//                     <TextBlock side='left'>
//                         <Md>{attention.mech1}</Md>
//                     </TextBlock>
//                     <Diagram src={d10} height={'15rem'} caption={'Adjectives'} side={'right'}/>
//                 </Row>
//                 <Row vcenter>
//                     <Diagram src={d11} height={'15rem'} caption={'Queries and Keys'} side={'left'}/>
//                     <TextBlock>
//                         <Md>{attention.mech2}</Md>
//                     </TextBlock>
//                 </Row>
//                 <Diagram scale src={d12} height={'25rem'} caption={'Computing delta'} side={'left'} center/>
//                 <TextBlock>
//                     <Md>{attention.mech3}</Md>
//                 </TextBlock>
//                 <Diagram src={d13} height={'20rem'} caption={'Computing delta'} side={'left'} center/>
//                 <TextBlock>
//                     <Md>{attention.mech4}</Md>
//                 </TextBlock>
//             </Section>
//             <Section title={'Attention: Code'} size='h3' mode={mode}>
//                 <CodeBlock mode={mode} text={attention.codetext}>{attention.attcode}</CodeBlock>
//                 <br />
//                 <br />
//                 <br />
//                 <Divider mode={mode}/>
//                 <TextBlock>
//                     <Md>{attention.attcodeexplanation1}</Md>
//                 </TextBlock>
//                 <CodeBlock>{attention.codep1}</CodeBlock>
//                 <br />
//                 <br />
//                 <br />
//                 <CodeBlock text={attention.attcodeexplanation2}>{attention.codep2}</CodeBlock>
//                 <Row>
//                     <TextBlock>
//                         <Md>{attention.attcodeexplanation3}</Md>
//                     </TextBlock>
//                     <CodeBlock>{attention.codep3}</CodeBlock>
//                 </Row>
//                 <Row>
//                     <TextBlock>
//                         <Md>{attention.attcodeexplanation4}</Md>
//                     </TextBlock>
//                     <CodeBlock>{attention.codep4}</CodeBlock>
//                 </Row>
//                 <Row>
//                     <TextBlock>
//                         <Md>{attention.attcodeexplanation5}</Md>
//                     </TextBlock>
//                     <CodeBlock>{attention.codep5}</CodeBlock>
//                 </Row>
//             </Section>
//             <Section title={'Multi-head Attention'} size='h3' mode={mode}>
//                 <TextBlock>
//                     <Md>{attention.mh1}</Md>
//                 </TextBlock>
//                 <Diagram src={d14} height={'15rem'} center scale caption={'Multi-head attention'}/>
//                 <CodeBlock mode={mode} text={'Code implementing parallel / multi attention heads:'}>
//                     {attention.mhcode}
//                 </CodeBlock>
//                 <TextBlock>
//                     <Md>
//                         Notice the projection at the end there, which puts the tokens back in the `d_embed` dimensional space.

//                         Thus, at the end of an attention block, the shape of the tokens remains unchanged.
//                     </Md>
//                 </TextBlock>
//             </Section>
//             <br />
//             <br />
//             <br />
//             <TextBlock>
//                 <Md>{attention.end}</Md>
//             </TextBlock>
//         </Section>
//     );
// }

// export function GPT({ mode }) {
//     return (
//         <Section title={'Putting it all together'} mode={mode}>
//             <TextBlock>{gpt.intro}</TextBlock>
//             <br />
//             <br />
//             <br />
//             <Section title={'Generation'} size='h3' mode={mode}>
//                 <Row vcenter>
//                     <TextBlock>
//                         <Md>{gpt.gen}</Md>
//                     </TextBlock>
//                     <Diagram src={d2} center width={'35rem'} caption={'Generation'} side={'right'}/>
//                 </Row>
//             </Section>
//         </Section>
//     );
// }


// export function FinishedCode({ mode }) {
//     return (
//         <Section title={'Final Code'} mode={mode}>
//             <Row vcenter>
//                 <TextBlock>
//                     <Md>{gpt.aboutdown}</Md>
//                 </TextBlock>
//                 <DownloadButton 
//                     mode={mode}
//                     filepath={gptzip}
//                     filename={'mini_llm'}
//                 />
//             </Row>
//         </Section>
//     );
// }
